// extracted by mini-css-extract-plugin
export var productImage = "_pb-1";
export var viewLink = "_pb-2";
export var wishlistItem = "_pb-0";